/*
 * @Author: Teemo Ding
 * @Date: 2022-04-17 10:32:37
 * @LastEditTime: 2023-04-14 16:00:09
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/ReportData/index.tsx
 */
import { Label } from '@/src/components/Antd';
import { ICategory } from '@/src/types/common/report';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import DateRange from '../../../Components/DateRange';
import ConfigDrawer from '../Components/ConfigDrawer';
import Filters from '../Components/Filters';
import css from '../css.module.less';
import { get } from 'lodash';
import { IDateRange } from '@/src/types/common/report';

const ReportData = (props: any) => {
  const {
    timeZone,
    onRefresh,
    onOpen,
    refreshDate,
    disabled,
    searchBtnLoading,
  } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { type } = useParams() as any;
  return (
    <Fragment>
      <SectionWrapper
        containerClassName={css.sectionContainer}
        titleClassName={css.titleClassName}
        title={getI18n('reports.reportData.title')}>
        <Form.Item
          name='dateRange'
          rules={[
            {
              validator: async (x, value) => {
                const dateRange = get(value, 'dateRange');
                const isCustom = IDateRange.Custom === dateRange;
                const beginDate = get(value, 'beginDate');
                const endDate = get(value, 'endDate');

                if (isCustom && (!!!beginDate || !!!endDate)) {
                  return Promise.reject(
                    new Error(getI18n('general.commonDate.pleaseselectadate')),
                  );
                }
              },
            },
          ]}
          label={
            <Label
              title={
                <div className={css.subTitleReportData}>
                  <div>
                    {replaceI18nVariables(
                      getI18n(`reports.reportData.datarange_gmt`),
                      timeZone,
                    )}
                  </div>
                  <div className={css.subTitleTipsReportData}>
                    {timeZone && (
                      <p className={css.generated}>
                        {replaceI18nVariables(
                          getI18n(`reports.reportData.datarange_desc`),
                          refreshDate,
                          timeZone,
                        )}
                      </p>
                    )}
                    {onRefresh && (
                      <span className={css.refresh} onClick={onRefresh}>
                        {getI18n('reports.reportData.refresh')}
                      </span>
                    )}
                  </div>
                </div>
              }
            />
          }
          labelCol={{ span: 24 }}
          className={css.reportName}>
          <DateRange
            size='large'
            additionalCustomerType={type === ICategory.Customer}
            type={type}
            refreshDate={refreshDate}
            disabled={disabled}
            onButtonClick={onRefresh}
            searchBtnLoading={searchBtnLoading}
          />
        </Form.Item>
      </SectionWrapper>
      <div className={css.filter}>
        <Filters onClick={onOpen} disabled={disabled} />
        <Form.Item name='dimensions' noStyle>
          <ConfigDrawer
            text={getI18n('reports.reportpagecommon.dimensions')}
            disabled={disabled}
          />
        </Form.Item>
        <Form.Item name='metrics' noStyle>
          <ConfigDrawer
            text={getI18n('reports.reportpagecommon.metrics')}
            disabled={disabled}
          />
        </Form.Item>
      </div>
    </Fragment>
  );
};

export default ReportData;
